import React from "react";
import EkselensMark from "./EkselensMark";

/**
 * StarMotif — DEPRECATED. Kept as a thin alias around <EkselensMark/> so the
 * dozen existing imports across the site automatically render the official
 * Ekselens 5-bar brand mark. Original asymmetric-bar SVG removed.
 *
 *  - size:  px height
 *  - color: ignored (the PNG asset is fixed brand purple). Accepted for
 *           back-compat with previous callers.
 */
const StarMotif = ({ size = 28, color, className = "", ...rest }) => (
  <EkselensMark size={size} color={color} className={className} {...rest} />
);

export default StarMotif;
